import React, { useEffect, useState } from 'react';
import { Box, Grid, Paper, Divider, Button, Avatar, Typography, IconButton } from '@mui/material';
import { PhotoCamera } from '@mui/icons-material';
import Controls from '../controls/Controls';
import EditIcon from '@mui/icons-material/Edit';
import { getProfileUser, updateUser } from '../../store/users';
import { useDispatch, useSelector } from 'react-redux';

const Profile = () => {
  const [editMode, setEditMode] = useState(false);
  const [profileData, setProfileData] = useState({
    username: 'Charles Xavier',
    email: 'chharlie4@example.com',
    phone: '989767231',
    status: 'Active',
    memberSince: 'January 1, 2020',
    imageUrl: 'https://via.placeholder.com/150',
  });
  const [uploadedImage, setUploadedImage] = useState(null);
  const useData = useSelector(getProfileUser)

  const dispatch = useDispatch()

  useEffect(()=>{
    if(useData){
      setProfileData(useData)
    }

  },[useData])

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfileData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle Update button
  const handleUpdateClick = () => {
    setEditMode((prev) => !prev);
  };

  // Handle image upload
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setUploadedImage(imageUrl);
    }
  };

  // Handle form submission
  const handleSubmit = () => {
    console.log('Updated Profile Data:', profileData);
    dispatch(updateUser(profileData))
    setEditMode(false); // Switch back to view mode

  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        mt: 5,
        p: 3,
        backgroundColor: '#f5f5f5',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Paper
        elevation={4}
        sx={{
          p: 4,
          width: '100%',
          height:"71vh",
          borderRadius: 3,
          backgroundColor: '#fff',
          position: 'relative',
          pt: 10,
        }}
      >
        {/* Profile Avatar with Upload Icon */}
        <Box sx={{ position: 'relative', textAlign: 'center' }}>
          <Avatar
            alt="User Profile"
            src={uploadedImage || profileData.imageUrl}
            sx={{
              width: 150,
              height: 150,
              position: 'absolute',
              top: -75,
              left: '50%',
              transform: 'translate(-50%, -50%)',
              border: '4px solid white',
            }}
          />
          <IconButton
            color="primary"
            component="label"
            sx={{
              position: 'relative',
              top: -20,
              right: 0,
              backgroundColor: 'white',
              '&:hover': { backgroundColor: '#f5f5f5' },
            }}
          >
            <PhotoCamera />
            <input hidden accept="image/*" type="file" onChange={handleImageUpload} />
          </IconButton>
        </Box>

        {/* Profile Header */}
        <Grid sx={{ padding: "0px" }} container direction="column" alignItems="center" spacing={1}>
          <Grid item>
            {editMode ? (
              <Controls.Input
                name="username"
                label="Full Name"
                value={profileData.username}
                onChange={handleInputChange}
              />
            ) : (
              <Typography variant="h4">{profileData.username}</Typography>
            )}
          </Grid>
          <Grid item>
            <Typography variant="body1" sx={{ fontSize: "20px" }} color="textSecondary">Admin</Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        {/* Profile Details */}
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom>Personal Information</Typography>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12}>
                {editMode ? (
                  <Controls.Input
                    name="email"
                    label="Email"
                    value={profileData.email}
                    onChange={handleInputChange}
                  />
                ) : <Typography variant="body1"><strong>Email:</strong> {profileData.email}</Typography>}
              </Grid>
              <Grid item xs={12} md={12}>
                {editMode ? (
                  <Controls.Input
                    name="phone"
                    label="Phone"
                    value={profileData.phone}
                    onChange={handleInputChange}
                  />
                ) : <Typography variant="body1"><strong>Phone:</strong> {profileData.phone}</Typography>}
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography sx={{ marginTop: "4px" }} variant="h6" gutterBottom>Account Information</Typography>
            <Typography sx={{ marginTop: "4px" }} variant="body1"><strong>Status:</strong> {profileData.status}</Typography>
            <Typography sx={{ marginTop: "4px" }} variant="body1"><strong>Member Since:</strong> {profileData.memberSince}</Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        {/* Update or Submit Button */}
        <Grid container justifyContent="center">
          {editMode ? (
            
            <Controls.Button
              text="Update"
              variant="outlined"
              size="small"
              startIcon={<EditIcon />}
              onClick={handleSubmit}
              sx={{
                color: 'black', 
                border: '1px solid black', 
                '&:hover': {
                  backgroundColor: 'black',
                  color: 'white',  
                  border: '1px solid black',
                },
              }}
            />

          ) : (
            <Controls.Button
              text="Edit"
              variant="outlined"
              size="small"
              startIcon={<EditIcon />}
              onClick={handleUpdateClick}
              sx={{
                color: 'black', 
                textTransform: 'none',
                border: '1px solid black', 
                '&:hover': {
                  backgroundColor: 'black',
                  color: 'white',  
                  border: '1px solid black',
                },
              }}
            />
          )}
        </Grid>
      </Paper>
    </Box>
  );
};

export default Profile;
